import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowUpRight } from 'lucide-react';

const ContactButton = () => {
  const { t } = useTranslation('editor');
  const navigate = useNavigate();

  return (
    <button
      onClick={() => {
        navigate('/contact');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      className="group relative hidden md:inline-flex items-center gap-2 overflow-hidden rounded-full px-5 py-2.5 text-sm font-semibold text-slate-950 bg-gradient-to-r from-cyan-300 via-sky-400 to-emerald-300 shadow-[0_0_30px_-8px_rgba(34,211,238,0.9)] hover:shadow-[0_0_40px_-6px_rgba(34,211,238,1)] transition-shadow duration-300"
    >
      <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/50 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
      <span className="relative">{t('nav.contact')}</span>
      <ArrowUpRight className="relative h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </button>
  );
};

export default ContactButton;
